import * as React from 'react';
import { StudentTeam } from 'Src/helpers/service/student/teams';
import { formatTeamAgesCompact } from 'Src/helpers/ageGroups';

interface Props { team: StudentTeam; viewerUserId?: string; ageGroupsNaming?: string; relationshipLabel?: string; subjectName?: string; }

export const TeamMembershipCard = ({ team, viewerUserId, ageGroupsNaming = 'ENGLISH', relationshipLabel = 'You', subjectName }: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [sportId, setSportId] = React.useState(team.sports[0]?.id || '');
  const selectedSport = team.sports.find(sport => sport.id === sportId) || team.sports[0];
  const ages = formatTeamAgesCompact(team.ages, ageGroupsNaming) || 'Open age';
  React.useEffect(() => {
    if (!isOpen) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previous; };
  }, [isOpen]);

  return <>
    <button type="button" className="studentTeamCard" onClick={() => setIsOpen(true)}>
      <div className="studentTeamCard__main"><span className="studentTeamCard__eyebrow">{team.season}</span><h2>{team.name}</h2>
        <div className="studentTeamCard__sportsInline">{subjectName && <span className="is-child">{subjectName}</span>}{team.sports.map(sport => <span key={sport.id}>{sport.name}</span>)}</div>
      </div>
      <div className="studentTeamCard__facts"><span>{ages}</span><span>{team.roster.length} {team.roster.length === 1 ? 'player' : 'players'}</span><b aria-hidden="true">›</b></div>
    </button>
    {isOpen && <div className="studentTeamDrawer" role="presentation" onMouseDown={event => event.target === event.currentTarget && setIsOpen(false)}>
      <aside role="dialog" aria-modal="true" aria-label={`${team.name} details`}>
        <header><div><span>{team.season}</span><h2>{team.name}</h2><p>{[ages, team.gender && team.gender.replace('_ONLY', '').toLowerCase()].filter(Boolean).join(' · ')}</p></div><button type="button" onClick={() => setIsOpen(false)} aria-label="Close team details">×</button></header>
        <div className="studentTeamDrawer__body">
          {team.description && <p className="studentTeamDrawer__description">{team.description}</p>}
          {team.sports.length > 1 && <nav aria-label="Choose sport">{team.sports.map(sport => <button type="button" className={selectedSport?.id === sport.id ? 'is-active' : ''} onClick={() => setSportId(sport.id)} key={sport.id}>{sport.name}</button>)}</nav>}
          {selectedSport && team.sports.length === 1 && <h3 className="studentTeamDrawer__sportTitle">{selectedSport.name}</h3>}
          <section className="studentTeamDrawer__roster"><div className="studentTeamDrawer__sectionHead"><h3>Team roster</h3><span>{team.roster.length}</span></div>
            {team.roster.map(player => {
              const isViewer = !!viewerUserId && player.userId === viewerUserId;
              const available = !player.sportIds?.length || !selectedSport || player.sportIds.map(String).includes(String(selectedSport.id));
              if (!available) return null;
              const assignment = player.positionsBySport?.find(item => String(item.sportId) === String(selectedSport?.id));
              const legacy = team.sports.length === 1 ? player : undefined;
              const positionName = assignment?.positionName || legacy?.positionName;
              const captain = assignment?.isCaptain ?? legacy?.isCaptain;
              const vice = assignment?.isViceCaptain ?? legacy?.isViceCaptain;
              const sub = assignment?.sub ?? legacy?.sub;
              const initials = `${(player.firstName || '').charAt(0)}${(player.lastName || '').charAt(0)}`.toUpperCase() || '?';
              return <div className={`studentTeamDrawer__player${isViewer ? ' is-related' : ''}`} key={player.id}><i>{initials}</i><div><strong>{player.firstName} {player.lastName}</strong><span>{positionName || 'Position not assigned'}</span></div><div className="studentTeamDrawer__badges">{isViewer && <em>{relationshipLabel}</em>}{captain && <b>C</b>}{vice && <b>VC</b>}{sub && <b>SUB</b>}</div></div>;
            })}
          </section>
        </div>
      </aside>
    </div>}
  </>;
};
